export const today = new Date().toLocaleDateString("en-CA", { timeZone: "Pacific/Auckland" });

export function applyTheme(dark) {
  if (dark) {
    document.documentElement.removeAttribute("data-theme");
  } else {
    document.documentElement.setAttribute("data-theme", "light");
  }
}

// JS colour values for components that can't use CSS vars (jsPDF, canvas)
// Also used inline where template literals are needed
export function makeColors(dark) {
  return dark ? {
    // Surfaces
    bg:       "#0F172A",
    surface:  "#1E293B",
    surface2: "#263445",
    input:    "#111827",
    // Borders
    border:   "#334155",
    divider:  "#475569",
    // Text
    text:     "#F8FAFC",
    textSec:  "#CBD5E1",
    label:    "#94A3B8",
    placeholder: "#64748B",
    // Brand
    blue:     "#1E5FA8",
    cyan:     "#2BACD1",
    green:    "#10B981",
    gray:     "#94A3B8",
    fail:     "#EF4444",
    // Status backgrounds (for inline use)
    failBg:   "#7F1D1D",
    greenBg:  "#064E3B",
    warnBg:   "#78350F",
    infoBg:   "#1E3A8A",
  } : {
    bg:       "#F1F5F9",
    surface:  "#FFFFFF",
    surface2: "#F8FAFC",
    input:    "#FFFFFF",
    border:   "#E2E8F0",
    divider:  "#CBD5E1",
    text:     "#0F172A",
    textSec:  "#334155",
    label:    "#64748B",
    placeholder: "#94A3B8",
    blue:     "#1E5FA8",
    cyan:     "#2BACD1",
    green:    "#059669",
    gray:     "#64748B",
    fail:     "#EF4444",
    failBg:   "#FEF2F2",
    greenBg:  "#ECFDF5",
    warnBg:   "#FFFBEB",
    infoBg:   "#EFF6FF",
  };
}
